import { render } from "./Purchase.vue?vue&type=template&id=31bbf25c"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__